import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth API
export const authAPI = {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    getMe: () => api.get('/auth/me'),
};

// Onboarding API
export const onboardingAPI = {
    submit: (data) => api.post('/onboarding/submit', data),
    getStatus: () => api.get('/onboarding/status'),
    refreshRyftStatus: () => api.post('/onboarding/refresh-status'),
};

// Admin API
export const adminAPI = {
    getStats: () => api.get('/admin/stats'),
    getApplications: (params) => api.get('/admin/applications', { params }),
    getApplication: (id) => api.get(`/admin/applications/${id}`),
    updateApplication: (id, data) => api.put(`/admin/applications/${id}`, data),
    updateStatus: (id, status) => api.put(`/admin/applications/${id}/status`, null, { params: { status } }),
    getSettings: () => api.get('/admin/settings'),
    updateSettings: (data) => api.put('/admin/settings', data),
    updateApiKeys: (data) => api.put('/admin/api-keys', data),
    createRyftAccount: (applicationId) => api.post('/onboarding/ryft/create-account', { application_id: applicationId }),
    createRyftLink: (applicationId, redirectUrl) => api.post('/onboarding/ryft/create-link', { application_id: applicationId, redirect_url: redirectUrl }),
    linkRyftAccount: (applicationId, ryftAccountId) => api.post('/onboarding/ryft/link-account', { application_id: applicationId, ryft_account_id: ryftAccountId }),
    refreshRyftStatus: (applicationId) => api.post(`/onboarding/ryft/refresh-status/${applicationId}`),
};

// Setup API
export const setupAPI = {
    createAdmin: () => api.post('/setup/create-admin'),
};

export default api;
